var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckAnimated = function SvgCheckAnimated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.28,
    d: "M2.5 7.5 6 11l6.5-7",
    pathLength: 1
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "300ms",
    from: 1,
    to: 0
  }))));
};
export default SvgCheckAnimated;